
import { EventBus } from './app/core/event-bus';
import store from './app/store';
import moment from 'moment';
import BootstrapVue from 'bootstrap-vue';



window.Vue = require('vue');
window.EventBus = EventBus;
window.moment = moment;


Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});
Vue.mixin({
    methods: {

        obj_to_null(someObject){
            if(someObject == null ) {
                return null;
            }

            let res = Object.keys(someObject).length;

            if(res === 0) {
                return null;
            }
            return someObject;
        }
    },

    filters: {
        uppercase: function (value) {
            if (!value) return '';
            value = value.toString();
            return value.toUpperCase();
        },
    },
});


let axios_c = require('axios');
window.axios_api = axios_c.create({
    baseURL: 'https://api.imcagro.com.ua/api/v1',
});

window.axios = axios_c.create();

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios_api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.qs = require('qs');
Vue.use(BootstrapVue);

store.dispatch('LOAD_MAIN_CONST');


$(document).ready(function () {

    if($("#user_auth").length > 0 ) {
        require('./app/components/user/index');
    }

    require('./app/sys/index');

});
